package ru.it_mozaika.sender.js.application

import io.ktor.client.request.forms.*
import io.ktor.client.statement.*
import io.ktor.http.*
import io.ktor.utils.io.core.*
import io.ktor.utils.io.js.*
import kotlinx.browser.localStorage
import kotlinx.datetime.*
import org.khronos.webgl.ArrayBuffer
import react.RBuilder
import kotlin.js.Date

fun idToDate(id: String): Date {
    val hexTimestamp = id.substring(0..7)
    val timestamp = hexTimestamp.toLong(16)*1000L
    return Date(timestamp)
}

fun String.idToDate() : Date = idToDate(this)

fun Double.format(digits: Int): String = this.asDynamic().toFixed(digits) as String
fun Float.format(digits: Int): String = this.asDynamic().toFixed(digits) as String

private var idNumber: Long = 0L
fun generateId(): String = "${++idNumber}"

fun Date.toLocalString(): String {
    val date = Date()
    val day = date.getDay()
    val month = date.getMonth()
    val hour = date.getHours()
    val minute = date.getMinutes()
    return "${if (day < 10) "0$day" else day}.${if (month < 10) "0$month" else month}.${date.getFullYear()} ${if (hour < 10) "0$hour" else hour}:${if (minute < 10) "0$minute" else minute}"
}

fun Instant.toLocalString(): String {
    val local = toLocalDateTime(TimeZone.currentSystemDefault())
    val day = local.dayOfMonth.toString().padStart(2, '0')
    val month = local.monthNumber.toString().padStart(2, '0')
    val year = local.year.toString().padStart(4, '0')

    val hour = local.hour.toString().padStart(2, '0')
    val minute = local.minute.toString().padStart(2, '0')
    val second = local.second.toString().padStart(2, '0')
    return "$day.$month.$year $hour:$minute:$second"
}

fun RBuilder.getParameter(frame: String, name: String): String? {
    return localStorage.getItem("$frame.$name")
}
fun RBuilder.setParameter(frame: String, name: String, value: String) {
    localStorage.setItem("$frame.$name", value)
}
fun excelUploadRequest(path: String, file: web.file.File, buffer: ArrayBuffer, query: Map<String, String>, response: (HttpResponse) -> Unit) {
    Http.post(
        path = path,
        query = query,
        body = MultiPartFormDataContent(
            formData {
                appendInput(
                    key = "file",
                    Headers.build {
                        append(
                            HttpHeaders.ContentDisposition,
                            value = "filename=objects.xlsx"
                        )
                    }, file.size.toLong()) {
                    buildPacket { writeFully(buffer) }
                }
            }
        ),
        callback = { respond ->
            response(respond)
        }
    )
}
fun String.localToInstant(): Instant {
    return (moment(this, "DD.MM.YYYY").toDate() as Date).toKotlinInstant()
}
fun String.convertFromLocalFormat(): String? {
    return try {
        val currentValue = this.split(".")
        listOf(currentValue[2], currentValue[1], currentValue[0]).joinToString("-")
    } catch (e: Exception){
        null
    }
}
fun String.convertIntoLocalFormat(): String? {
    return try {
        val currentValue = this.split("-")
        listOf(currentValue[2], currentValue[1], currentValue[0]).joinToString(".")
    } catch (e: Exception){
        null
    }
}